export const SERVICE_TEMPLATE_ID = {
  HOT_COLD: 33,
  DANGEROUS: 36,
  SPACE_RESERVATION: 39,
  BUILDING_MENU: 41,
  TOILET_EMPTY: 42,
  OFF_WORK_HOT_COLD: 51,
  ETC_PARKING: 75,
  ETC: 83,
  SANDI_MARKET: 1003,
};

export const SERVICE_DETAIL_ITEM_TYPE = {
  OUR_HOME: "membership-card",
  SMART_OLIVE: "membership-card-olive",
  CAFETERIA: "cafeteria",
};
